import { render, staticRenderFns } from "./modelo_disciplina_certificado.vue?vue&type=template&id=3f278a97&"
import script from "./modelo_disciplina_certificado.vue?vue&type=script&lang=js&"
export * from "./modelo_disciplina_certificado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports